export default __webpack_public_path__ + "static/media/Maven-Capital-Tight-Black.9fca369a.png";